(function () {
  const grids = document.querySelectorAll('[data-ll-color-crossfade]');
  if (!grids.length) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return;

  grids.forEach(function (grid) {
    const tiles = grid.querySelectorAll('.ll-collection-tile:not(.ll-collection-tile--view-all)');
    if (!tiles.length) return;

    let tick = 0;
    setInterval(function () {
      tick = (tick + 1) % 42;
      tiles.forEach(function (tile) {
        const images = tile.querySelectorAll('.ll-collection-tile__image img');
        if (images.length < 2) return;
        const activeIndex = tick % images.length;
        images.forEach(function (img, i) {
          img.classList.toggle('is-active', i === activeIndex);
        });
      });
    }, 2000);
  });
})();
